import {
  getLayoutTypePath,
  isLayoutPGOneColumn,
  isLayoutPGSideBySide,
  LAYOUT_PG_GRID,
  SECTION_POST_LIST,
} from '@wix/communities-blog-client-common';
import { get } from 'lodash';
import { getAppSettings } from '../../common/selectors/app-settings-base-selectors';
import { getDefaultLayout } from '../../common/selectors/layout-selectors';

export const getPostListLayoutType = ({ state, isMobile }) => {
  const mobileLayoutType = getLayoutTypeParam({ state, isMobile: true });
  const defaultLayout = getDefaultLayout(state);
  const desktopLayoutType = getLayoutTypeParam({ state, defaultLayout });
  let layoutType = (isMobile && mobileLayoutType) || desktopLayoutType;

  if (isMobile && (isLayoutPGSideBySide(layoutType) || isLayoutPGOneColumn(layoutType))) {
    layoutType = LAYOUT_PG_GRID;
  }

  return layoutType;
};

const getLayoutTypeParam = ({ state, isMobile, defaultLayout }) => {
  return get(getAppSettings(state), getLayoutTypePath(SECTION_POST_LIST, isMobile), defaultLayout);
};
